import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";
import { LanguageProvider } from "./context/LanguageContext";
import SmoothScroll from "./components/SmoothScroll";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import PaymentSuccess from "./pages/PaymentSuccess";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

function Shell() {
  const loc = useLocation();
  const bare = loc.pathname.startsWith("/admin") || loc.pathname === "/login";

  if (bare) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <SmoothScroll>
      <Nav />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/equipos" element={<Catalog fixedCategory="physical" />} />
          <Route path="/software" element={<Catalog fixedCategory="software" />} />
          <Route path="/consultoria" element={<Catalog fixedCategory="consulting" />} />
          <Route path="/producto/:slug" element={<ProductDetail />} />
          <Route path="/carrito" element={<Cart />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </main>
      <Footer />
    </SmoothScroll>
  );
}

function App() {
  return (
    <LanguageProvider>
      <StoreProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </StoreProvider>
    </LanguageProvider>
  );
}

export default App;
